// export let BASE_URL = "https://developer-beta.com/p5/otobix/api"
// export let BASE_IMAGE_URL = "https://developer-beta.com/p5/otobix/"
// export let BASE_FONT_URL = "https://developer-beta.com/"

export let BASE_URL = "https://otobix.in/admin/api"
export let BASE_IMAGE_URL = "https://otobix.in/admin/"
export let BASE_FONT_URL = "https://otobix.in/"